<template>
  <div class="payment" ref='paymentTop'>
    <div class='content'>
      <div class='logo'>shopping</div>
        
        <div class='steps'>
          <div class='step1' v-if="step==1">
            <label class='paymentBlock paymentflex' >
              <div class='paymentColumn'  style="flex:1;" ><input type='radio' name='shipping'></div>
              <div class='paymentColumn' style="flex:4;">
                <img src='../assets/icon_6.svg' />
                <div class='paymentColumnBlack'>宅配到家</div>
                <div class='paymentColumnRed'>滿1000元免運，運費100元</div>
              </div>
              <div class='paymentColumn' style="flex:6;">
                <div class='paymentText'>信用卡付款</div>
                <div class='paymentText'>ATM轉帳</div>
                <div class='paymentText'>貨到付款</div>
              </div>
            </label>  
            <label class='paymentBlock paymentflex' >
              <div class='paymentColumn' style="flex:1;" ><input type='radio' name='shipping'></div>
              <div class='paymentColumn' style="flex:4;" >
                <img src='../assets/icon_1.svg' />
                <div class='paymentColumnBlack'>便利商店取貨</div>
                <div class='paymentColumnRed'>滿888元免運，運費60元</div>
              </div>
              <div class='paymentColumn' style="flex:6;" >
                <div class='paymentText'>信用卡付款</div>
                <div class='paymentText'>ATM轉帳</div>
                <div class='paymentText'>貨到付款</div>
              </div>
            </label> 
            <div class='paymentBlock summary'>
              <div class='summaryRow'>
                <div>600   元</div>
                <div>商品金額</div>
                <div>共3件</div>
              </div>
              <div class='summaryRow'>
                <div>60   元</div>
                <div>運費</div>
                <div>再買 <span style='color:red;'>340元</span> 免運費</div>
              </div>
              <div class='summaryLine'></div>
              <div class='summaryRow'>
                <div>660  元</div>
                <div>應付金額</div>
              </div>              
            </div> 
            <div class='submit'>
                <a href='#' @click="back">回購物車</a>
                <a href='#' @click="step1">確認送出</a>
            </div>
          </div>
          <div class='step2' v-if='step==2'>
            <div class='paymentBlock'>
              <div class='fillElement'>
                <div class='fillTitle'>收件人</div>
                <div><input type='text' class='inputfill'  v-model="receiver" /></div>
              </div>
              <div class='fillElement'>
                <div class='fillTitle'>手機號碼</div>
                <div><input type='text' class='inputfill' /></div>
              </div>              
              <div class='fillElement'>
                <div class='fillTitle'>地址</div>
                <div><input type='text' class='inputfill' /><input type='text' class='inputfill' /></div>
              </div>
              <div class='fillElement' style='padding-bottom:20px'>
                <div class='fillTitle'>發票類型</div>
                <div class='invoiceBlock'>
                  <div class='invoiceOption'><input type='radio' name='invoice' id='radio1' /><label for='radio1'>個人 - 二聯電子發票</label></div>
                  <div class='invoiceOption'><input type='radio' name='invoice' id='radio2'  /><label for='radio2'>公司 - 統一編號</label></div>
                  <div class='invoiceOption'><input type='radio' name='invoice' id='radio3' /><label for='radio3'>捐贈發票</label></div>
                  <div class='invoiceOption'><input type='radio' name='invoice' id='radio4' /><label for='radio4'>個人 - 手機條碼載具</label></div> 
                </div>     
              </div>
              </div>
              <div class='paymentBlock summary' >
                 <div class='orderInfoTitle'>訂單資訊</div>
                 <div class='orderInfoRow'>
                   <div style='font-weight: bold;'>宅配到府</div>
                   <div>運送方式</div>
                 </div>
                 <div class='summaryLine'></div>
                 <div class='orderInfoRow'>
                  <div>700 元</div>
                  <div>訂單金額</div>
                 </div>
               </div>
              <div>
                <label class='paymentBlock paymentMethodflex' >
                  <div class='paymentColumn'  style="flex:1;" ><input type='radio' name='paymentMethod'></div>
                  <div class='paymentColumn'  style="flex:2;" >信用卡付款</div>
                  <div class='paymentColumn' style="flex:2;"><img src='../assets/credit_icon_1.svg' /></div>
                </label>
                <label class='paymentBlock paymentMethodflex' >
                  <div class='paymentColumn'  style="flex:1;" ><input type='radio' name='paymentMethod'></div>
                  <div class='paymentColumn'  style="flex:2;" >ATM轉帳</div>
                  <div class='paymentColumn' style="flex:2;"><img src='../assets/ATM_icon_2.svg' /></div>
                </label>
                <label class='paymentBlock paymentMethodflex' >
                  <div class='paymentColumn'  style="flex:1;" ><input type='radio' name='paymentMethod'></div>
                  <div class='paymentColumn'  style="flex:2;" >貨到付款<br/>取貨付款</div>
                  <div class='paymentColumn' style="flex:2;"><img src='../assets/money_icon_2.svg' /></div>
                </label>
              </div>
             
          <div class='submit'>
            <a href='#' @click="back">重選配送方式</a>
            <a href='#' @click="step2">確認送出</a>
          </div>
          </div>
            <div class='step3' v-if='step==3'>
              <div class='twoCard'>
              <img  class='card cardRWD1' src='../assets/card1.png' />
              <img  class='card cardRWD2' src='../assets/card2.png' />
              </div>
              <div class='paymentBlock '>
                <div class='fillElement'>
                  <div class='fillTitleCard'>信用卡卡號</div>
                  <div class='inputfillRow'>
                          <input type='text' class='inputfillCard' name='test' maxlength='4' @keypress="isNumber($event)" /><div class='cardDash'>-</div>
                         <input type='text' class='inputfillCard' maxlength='4' @keypress="isNumber($event)"  /><div class='cardDash'>-</div>
                         <input type='text' class='inputfillCard' maxlength='4' @keypress="isNumber($event)"  /><div class='cardDash'>-</div>
                         <input type='text' class='inputfillCard' maxlength='4' @keypress="isNumber($event)"  />
                  </div>
                </div>
                <div class='fillElement'>
                  <div class='fillTitleCard'>有效期限</div>
                  <div class='inputfillRow'>
                    <input type='text' class='inputfillCard' name='test' maxlength='2' @keypress="isNumber($event)" /><div class='cardDash'>月&nbsp;/</div>
                    <input type='text' class='inputfillCard' maxlength='2' @keypress="isNumber($event)"  /><div class='cardDash'>年</div>
                  </div>
                </div>
                <div class='fillElement'>
                  <div class='fillTitleCard'>CVC 背後末三碼</div>
                  <div class='inputfillRow'>
                    <input type='text' class='inputfillCard' name='test' maxlength='3' @keypress="isNumber($event)" style='margin-right:150px;' />
                    <label class='keepCredit'> <input type='checkbox' /><div  class='keepCreditText'>是否儲存此信用卡</div></label>
                  </div>
                </div>  
                <div class='fillElement'>
                  <div class='fillTitle'>常用信用卡</div>
                  <div class='inputfillColumn' >
                      <label class='creditList'> 
                        <input type='radio' name="card_usually" >
                        <img class='cardListImg' src='../assets/Image_1.png'/>
                        xxxx-xxxx-xxxx-xxxx
                      </label>
                      <label class='creditList'  > 
                        <input type='radio' name="card_usually">
                        <img class='cardListImg' src='../assets/Image_2.png'/>
                        xxxx-xxxx-xxxx-xxxx
                      </label>
            
                  </div>
                </div>             
              </div>
               <div class='submit'>
                <a href='#' @click="back">回上一步</a>
                <a href='#' >確認送出</a>
            </div>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Payment',
  data: function (){
    return {
        step: 1,
        receiver:'',


    }
  },
  props: {
    msg: String
  },
  methods:{
      step1: function(){
        this.step = 2
      },
      step2: function(){
        this.step = 3
      },
      back: function(){
        if (this.step == 1) return;
        this.step = this.step - 1
      },
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      toNext: function(evt){
        return true;
        console.log('12');
        var el = evt.currentTarget;
        console.log(el);
        if (el.value.length == el.maxLength) {
          var next = el.nextElementSibling.innerHTML
          console.log(next)
        if (next.length)
            next.focus();
        else
            el.blur();
      }
    }  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
  
.payment{
  width:100%;
  min-height: 100vh;
  background: #F8F2ED;
}

.content{
  padding-top:55px;
  margin: 0 20px;
}

.steps{
  /* width: 80%; */
  max-width: 600px;
  margin: 0px auto;
}
.logo{
  text-transform: uppercase;
  color:#FFF;
  background: #843C05;
  width: 92.02px;
  height:33.533px;
  text-align: center;
  font-weight: bold;
  line-height: 33.533px;
  margin-bottom: 40px;

  /* display: inline-block; */
}
.step1block{
  margin: 40px 0 0;
}


.paymentBlock{
  width:100%;
  min-height:128px;
  border-radius: 8px;

  background: #FFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
  margin-top:10px;


  /* margin-right: 50px; */
}

.paymentflex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
}
.paymentColumn{
  padding: 20px;
  
}

.paymentColumnRed{
  color: #FF0202;
  font-size: 10px;
  text-align: center;
}

.paymentColumnBlack{
  color: #000;
  font-size: 12px;
  text-align: center;
  line-height: 16px;
  font-weight: bold;

}

.paymentText{
  font-style: 'Segoe UI';
  letter-spacing: 1.2px;
  font-size:12px;
  line-height: 16px;
  font-weight: bold;
  text-align: center;
  margin: 4px auto;

}

.summary{
  display: flex;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.16);
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding:20px 0px;
  flex-basis: 50%;
}

.summaryLine{
  width:80%;
  border:#D2D2D2 1px;
  border-style: solid;
}

.summaryRow{
  display: flex;
  padding-left:10px;
  flex-direction:row-reverse;
  width:80%;
}

.summaryRow > *{
  font-style: 'Segoe UI';
  font-size:14px;
  /* width:120px; */
  margin-left:10px;
  text-align: right;
  min-width:  80px;
}

.submit{
  width:70%;
  height:40px;
  padding:20px;
  display: flex;
  justify-content: space-around;
  margin:0px auto;
  flex-basis: 100%;
}

.submit a{
  width:100px;
  height:44px;
  display: block;
  background-color: #A99C92;
  border-radius: 8px;
  line-height: 44px;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.16);
  font-style: 'Segoe UI';
  font-size:13px;
  color:white;
  text-decoration: none;
  &:hover{
     background-color: #703302;
  } 
  
}
.fillElement{
  display:flex;
  
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 0px;
  justify-content: left;
  flex-direction: column;

}

.fillTitle{
  font-style:'Segoe UI';
  font-size: 16px;
  text-align: left;
  padding: 0px 10px 5px 0px;
}

.fillTitleCard{
  font-style:'Segoe UI';
  font-size: 14px;
  text-align: left;
  padding: 0px 10px 5px 0px;
}

.inputfill{
  // padding: 10px 0px;
  margin: 10px 0px;
  padding-top: 10px;
  line-height: 16px;
  width:100%;
  border: none;
  font-size: 16px;
  justify-self: left;
  border-bottom: 1px solid rgba(173, 173, 173, 1);
}

.inputfillRow{
  display: flex;
  flex-wrap:wrap;
}

.inputfillColumn{
  display: flex;
  flex-wrap:wrap;
  flex-direction: column;
  justify-items: flex-start;
}
.cardDash{
  height: 60px; 
  line-height: 60px;
  padding:0px 5px;
}


.inputfillCard{
  // padding: 10px 0px;
  display:flex;
  justify-self: left;
  margin: 13px 0px;
  padding-top:5px;
  width: 45px;
  border: none;
  font-size: 15px;
  text-align: center;
  border-bottom: 1px solid rgba(173, 173, 173, 1);
}

.keepCredit{
  display: flex;
  font-size:12px;
  height: 30px;
  padding-right:100px;
  vertical-align: bottom;
  text-indent: bottom;
  align-self: center;
}

.keepCreditText{
  padding:0px 5px;
  display: flex;
  width:200px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}


// .invoiceOption{
 

//   &:checked {
//     border: 1px rgba(0, 0, 0, 0.16);
//     font-size:12px;
    

//   }
// }


.invoiceOption > label {
  margin: 5px;
  padding: 5px;
  // width:135px;
  height:44px;
  min-width: 100px;
  
  cursor: pointer;
  font-size:12px;
  font-weight: bold;
  font-style: 'Segoe UI';
}
.invoiceOption > input{
  visibility:hidden;
}

.invoiceOption > input + label {
  color:#ADADAD;
  border-radius: 8px;
  display: block;
  line-height: 44px;
  border: rgba(0, 0, 0, 0.16) 1px solid;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.50);
}

.invoiceOption > input:checked + label {
  color:#000;
  line-height: 44px;
  box-shadow: none;
  border: rgb(0, 0, 0) 1px solid;
}

.invoiceBlock{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}


.orderInfoTitle{
  padding:10px 0;
  font-style:'Segoe UI';
  font-size: 16px;
  text-align: center;
}

.orderInfoRow {
  display: flex;
  padding-left:10px;
  flex-direction:row-reverse;
  justify-content: space-between;
  width:80%;
}

.orderInfoRow > * {
  font-style: 'Segoe UI';
  font-size:15px;
  /* width:120px; */
  margin-left:10px;
  text-align: center;
  min-width:  80px;
}

.paymentMethodflex{
  width:95%;
  min-width: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
}

.card{
  width:237px;
  height: 152px;
}


@media screen and (max-width: 600px) {
  .twoCard{
    width:400px;
    height: 250px;
    position: relative;
    margin: 0 auto;
  }
  .cardRWD1{
    position: absolute;
    top:0px;
    left:10px;
    width:237px;
    height: 152px;
    z-index: 1;
  }
  .cardRWD2{
    position: absolute;
    right:0px;
    bottom:20px;
    width:237px;
    height: 152px;
    z-index: 0;
  }

}


.cardListImg{
  width:30px;
  height:20px;
  border-radius: 4px;
  border:  solid 1px rgba(0, 0, 0, 0.16) ;
}


.creditList{
  display:flex;
  align-items: center;
  justify-items: center;
  border-radius: 8px;
  border: solid 1px rgba(0, 0, 0, 0.16) ;
  width: 300px;
  height: 40px;
  margin: 10px ;

}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.step2{
  // display: flex;
  justify-content: space-between;
  // flex-wrap: wrap;
}
.aaa{
  flex-basis: 10%;
}
.bbb{
  flex-basis: 20%;
}
</style>
